// extracted by mini-css-extract-plugin
export var section = "_2o-1";
export var topNav = "_2o-0";